import React from "react";
import Packaging from "components/app/report/environment/packaging/Packaging";

type ScreenPackagingProps = React.PropsWithChildren<{}>;

function ScreenPackaging(props: ScreenPackagingProps) {
	return <Packaging />;
}

export default ScreenPackaging;
